<template>
  <div class="border">
    <h4>{{ "discounts" | setText("Скидки на товары") }}</h4>
    <list
      :columns="columns"
      :modalCreate="modalCreate"
      :isAdd="true"
      title_add="Добавить скидку на товар"
      title_add_key="add_discount"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="false"
      :openItem="false"
      :itemLink="itemLink"
      :setLink="setLink"
      :fields="fields"
      :searchDisable="true"
      @change="change"
      @input="change"
      @changeFunction="changeFunction"
      @deleted="$emit('deleted', true)"
      v-model="val"
    />
  </div>
</template>
<script>
import { logger } from "../../../plugins/functions";

export default {
  components: {},
  name: "products",
  props: {
    order: {
      default: null,
    },
  },
  created() {
    this.itemLink = `orders/${this.order.id}/discounts`;
    this.setLink = `orders/${this.order.id}/discounts`;
  },
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      val: [],
      modalCreate: "purchase",
      fields: [
        {
          label: "Выберите товар с заказа",
          labelKey: "purchase_item",
          key: "purchase",
          type: "select-full",
          modal: "purchase",
          url: `orders/${this.order.id}/purchases`,
          selectKey: "name",
        },
        {
          col: "col-12",
          label: "IMEI нового устройства",
          key: "imei_purchse",
          type: "field",
          type: "mask",
          mask: "###############",
        },
        {
          label: "Услуга",
          labelKey: "service",
          key: "service",
          type: "select-full",
          modal: "service",
          fieldKey: "id",
          selectKey: "name",
          params: { type_object: "2" },
          push: {
            "trade-in": {
              parentPush: "service",
              label: "Выберите скидку",
              labelKey: "sale",
              key: "trade_in",
              type: "select-full",
              modal: "trade-in",
              fieldKey: "id",
              selectKey: "name",
              params: { client_id: this.order.client_id },
            },
          },
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_purchase",
      itemLink: "purchases",
      setLink: "purchases",
      columns: [
        {
          key: "purchase",
          object: "purchase",
          titleKey: "purchase",
          title: "Покупка",
          object: "name",
          disableLink: true,
        },
        {
          key: "promotion",
          object: "name",
          titleKey: "sale",
          title: "Акция",
          disableLink: true,
        },
        {
          key: "trade_in",
          object: "name",
          titleKey: "trade_in",
          title: "Трейд-ин",
          disableLink: true,
        },
        {
          key: "discount_total",
          titleKey: "discount_total",
          title: "Скидка на товары",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          price: true,
        },
        {
          remove: true,
        },
      ],
    };
  },
};
</script>